import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    rowItemsWrapper: {
      display: "flex",
      alignItems: "center",
    },
    alignRight: {
      justifyContent: "flex-end",
    },
    itemsGap: {
      gap: theme.spacing(4),
    },
    tooltipIcon: {
      opacity: 1,
    },
    tooltipTitle: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
      color: theme.gray800,
    },
    tooltipDescription: {
      whiteSpace: "break-spaces",
      marginTop: theme.spacing(2),
      fontSize: "12px",
      lineHeight: "20px",
      fontWeight: 400,
    },
    warningIcon: {
      color: theme.orange500,
      height: "16px",
      width: "16px",
    },
    barChart: {
      width: "65px",
    },
  }),
);
